export type FormValidatorFn = (value: any) => string | null;

export enum FormValidationErrors {
    Required = 'Dit veld is verplicht.',
    Email = 'Vul een valide e-mail adres in',
    Phone = 'Vul een mobiel telefoonnummer in dat uit maximaal 10 karakters bestaat',
    IBAN = 'Vul een geldige IBAN in',
    Date = 'Vul een geldige datum in (dd-mm-jjjj)',
}
